const enum STANDARD_FIELD_TYPES {
  text = 'Text',
  date = 'Date',
  file = 'File',
  time = 'Time',
  select = 'Select',
  phone = 'Phone',
  datePicker = 'DatePicker',
  signature = 'Signature',
  number = 'Number',
  hidden = 'hidden',
}

const enum STANDARD_FIELD_V2_TYPES {
  text = 'TEXT',
  date = 'DATE',
  file = 'FILE',
  time = 'TIME',
  select = 'SELECT',
  phone = 'PHONE',
  datePicker = 'DATEPICKER',
  signature = 'SIGNATURE',
  number = 'NUMBER',
  hidden = 'HIDDEN',
}

export {STANDARD_FIELD_TYPES, STANDARD_FIELD_V2_TYPES};
